export const mutations = {
  setCurrency(state, payload) {
    state.currency = payload;
  },
};
